import { render, staticRenderFns } from "./PerformanceReviewTemplateSelector.vue?vue&type=template&id=3331a26e&"
import script from "./PerformanceReviewTemplateSelector.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewTemplateSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports